import React from 'react'
import { Button } from '../../../components/Button/Button'
import crossClientLogo from '../../../assets/images/cross-client-logo.png'
import { FrequencyUnits, MONTH_LABELS, WEEKDAY_LABELS, formatNextRun, getNextRun, ordinal, type ScheduledQueryFrequency } from './scheduledQueryFrequency'

const describeSchedule = (frequency: ScheduledQueryFrequency): string => {
  switch (frequency.unit) {
    case FrequencyUnits.MONTH:
      return `every month on the ${ordinal(frequency.dayOfMonth)}`
    case FrequencyUnits.YEAR:
      return `every year on ${MONTH_LABELS[frequency.month]} ${ordinal(frequency.dayOfMonth)}`
    case FrequencyUnits.WEEK:
    default:
      return `every ${WEEKDAY_LABELS[frequency.dayOfWeek]}`
  }
}

interface ScheduledQuerySuccessProps {
  frequency: ScheduledQueryFrequency
  onGoBack: () => void
}

export const ScheduledQuerySuccess: React.FC<ScheduledQuerySuccessProps> = ({ frequency, onGoBack }) => {
  const nextRun = getNextRun(frequency)
  return (
    <div className='d-flex flex-column align-items-center gap-4 mt-10'>
      <div className='position-relative'>
        <img src={crossClientLogo} alt='' className='scheduled-query-success-logo' />
        <i className='bi bi-check-circle-fill zocks-text-success position-absolute scheduled-query-success-check' aria-hidden='true' />
      </div>
      <div className='d-flex flex-column align-items-center gap-2'>
        <h4 className='mb-0'>Query scheduled</h4>
        <div className='d-flex flex-column align-items-center'>
          <span className='paragraph-medium'>
            This query will run{' '}
            <span className='medium'>
              {describeSchedule(frequency)}
              {nextRun ? `, starting ${formatNextRun(nextRun)}` : ''}.
            </span>
          </span>
          <span className='paragraph-medium'>Results will be ready at the start of the day.</span>
        </div>
      </div>
      <Button variant='primary' className='button-medium' onClick={onGoBack}>
        Go back to query
      </Button>
    </div>
  )
}
